import UserPreferences from "../models/user-preference";

export default {
    init: function ( $element ) {
        "use strict";
        var _this = this;

        _this.$body = $element;
        _this.$rightSidebar = $element.find( ".right-sidebar" );
        _this.defaultTheme = $element.attr( "class" )
            .split( /-(.+)/ );

        _this.setSkinListHeightAndScroll();
        _this.setSettingListHeightAndScroll();

        return _this;
    },

    activate: function () {
        "use strict";
        var _this = this,

            $li = _this.$rightSidebar.find( ".demo-choose-skin li" ),
            resizeId;

        // Set defualt theme
        $li.each( function ( index, el ) {
            var attrValue = $( el )
                .attr( "data-theme" );
            if ( attrValue === _this.defaultTheme[ 1 ] ) {
                $( el )
                    .addClass( "active" );
                return false;
            }
        } );

        $li.on( "click", function ( event ) {
            event.stopImmediatePropagation();
            var $this = $( this ),
                colorThemeObj = Vistracks.Scope.AppState.attr( "themeColorObj" ),
                requestMethod = "POST";

            var existTheme = _this.$rightSidebar
                .find( ".demo-choose-skin li.active" )
                .data( "theme" );

            _this.$rightSidebar.find( ".demo-choose-skin li" )
                .removeClass( "active" );
            _this.$body.removeClass( "theme-" + existTheme );
            $this.addClass( "active" );

            _this.$body.addClass( "theme-" + $this.data( "theme" ) );

            // Set the report button's icon background color
            _this.setReportBtnsBgColorIcon( existTheme, $this.data( "theme" ) );

            var preferenceParams = [{
                userId: Vistracks.myUser.id,
                key: "COLOR_THEME",
                prefType: "STRING_PREF",
                stringVal: "theme-" + $this.data( "theme" ),
                displayName: "Color Theme",
                isEditable: true
            }];

            var param = {
                userPreferences : preferenceParams
            };

            if ( colorThemeObj ) {
                requestMethod = (colorThemeObj.length !== 0) ? "PUT" : "POST";
            }

            if( requestMethod === "PUT" ) {
                preferenceParams[0].id = colorThemeObj[0].id;
                param.id = colorThemeObj[0].id;
            }

            var color_theme = new UserPreferences( param );
            color_theme.save().then(
                responseData => {
                    Vistracks.Scope.AppState.attr( "themeColorObj", responseData );
                    Vistracks.Scope.AppState.attr( "themeColor", "theme-" + $this.data( "theme" ) );
                },
                responseData => Vistracks.HelperUtils.jqXHRerror( responseData.status )
            );

        } );

        // Adjust the height and scroll of skin changer and settings tabs
        $( window )
            .resize( function () {
                clearTimeout( resizeId );
                resizeId = setTimeout( function () {
                    _this.setSkinListHeightAndScroll();
                    _this.setSettingListHeightAndScroll();
                }, 20 );
            } );
    },

    setReportBtnsBgColorIcon: function ( existingTheme, currentTheme ) {
        "use strict";
        var reportBtns = $( ".report-button__icon" );

        can.each( reportBtns, function ( el ) {
            var element = $( el );

            element.removeClass( "bg-" + existingTheme + "-300" )
                .addClass( "bg-" + currentTheme + "-300" );
        } );

        // Clear the cache element
        reportBtns = null;
    },

    setSkinListHeightAndScroll: function () {
        "use strict";
        var _this = this,

            height = $( window )
            .height() - ( $( ".navbar" )
                .innerHeight() + $( ".right-sidebar .nav-tabs" )
                .outerHeight() ),
            $el = _this.$body.find( ".demo-choose-skin" );

        $el.slimScroll( {
                destroy: true
            } )
            .height( "auto" );
        $el.parent()
            .find( ".slimScrollBar, .slimScrollRail" )
            .remove();

        $el.slimscroll( {
            height: height + "px",
            color: "rgba(0,0,0,0.5)",
            size: "4px",
            alwaysVisible: false,
            borderRadius: "0",
            railBorderRadius: "0"
        } );
    },

    setSettingListHeightAndScroll: function () {
        "use strict";
        var _this = this,

            height = $( window )
            .height() - ( $( ".navbar" )
                .innerHeight() + $( ".right-sidebar .nav-tabs" )
                .outerHeight() ),
            $el = _this.$rightSidebar.find( ".demo-settings" );

        $el.slimScroll( {
                destroy: true
            } )
            .height( "auto" );
        $el.parent()
            .find( ".slimScrollBar, .slimScrollRail" )
            .remove();

        $el.slimscroll( {
            height: height + "px",
            color: "rgba(0,0,0,0.5)",
            size: "4px",
            alwaysVisible: false,
            borderRadius: "0",
            railBorderRadius: "0"
        } );
    }
};
